import React, { Component } from 'react';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import BasicTemplate from './BasicTemplate.js'
import {FormattedHTMLMessage} from 'react-intl';

class Pending extends Component {

    constructor(props) {
        super(props);
        this.state = { pending: '' };
    }

    render() {
        return (
            <BasicTemplate>
                <FormattedHTMLMessage id="app.step_pending" description="Pending Info"/>
            </BasicTemplate>
        );
    }
}

Pending = TopScrolleable(Pending);

Pending = withAuthControl(Pending);

export default Pending;



/** WEBPACK FOOTER **
 ** ./src/components/Pending.js
 **/